import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { isStore, isTechStore } from '../Authetication'



export default function TechStoreRoutes() {


  let auth = {"token": isTechStore()}

  

  return (
   auth.token ? <Outlet/> : <Navigate to="/dashboard"/>
  )
}
